import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/rexue', label: '分类' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-flower-line text-2xl text-primary-500"></i>
          </div>
          <span className="font-heading text-xl text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            樱花动漫之家
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === link.to
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-foreground-600 text-sm"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-foreground-700 text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-lg text-sm transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}